<a (click)="onClick($event)" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl">
  <sd-media
    [width]="width"
    [height]="height"
    [container]="product.images?.PRIMARY"
    [alt]="product.name"
    [loading]="loadImageEagerly ? 'eager' : 'lazy'"
    [fetchpriority]="loadImageEagerly ? 'high' : 'auto'"
  ></sd-media>
</a>
